import { useUserStore } from '@/stores/user';

const { hasFeatureFlag } = useUserStore();

const compliantKeys = {
  'global.actions.delete_item': 'global.actions.cancel_item',
  'reports.ranges.orders': 'reports.ranges.sales',
  'giftcard.delete_warning': 'giftcard.sale_delete_warning',
  'prepaid_card.delete_warning': 'prepaid_card.sale_delete_warning',
  'appointment.features.order': 'appointment.features.sale_order',
  'appointment.features.payment_draft':
    'appointment.features.sale_payment_draft',
  'appointment.features.payment_outstanding':
    'appointment.features.sale_payment_outstanding',
  'global.flash.order_updated': 'global.flash.sale_updated',
  'timeline_items.log.order_created': 'timeline_items.log.sale_created',
  'timeline_items.log.order_updated': 'timeline_items.log.sale_updated',
  'timeline_items.log.order_removed': 'timeline_items.log.sale_removed',
  'logs.order_removed': 'logs.sale_removed',
  'logs.order_updated': 'logs.sale_updated',
  'logs.order_created': 'logs.sale_created',
  'register.scan_product_description': 'register.sale_scan_product_description',
  'register.appointment_paid': 'register.sale_appointment_paid',
  'register.attach_note': 'register.sale_attach_note',
  'register.deleted': 'register.sale_deleted',
  'register.edit_warning': 'register.sale_edit_warning',
  'register.general_error': 'register.sale_general_error',
  'register.draft_notice': 'register.sale_draft_notice',
  'register.saved_as_draft': 'register.sale_saved_as_draft',
  'register.saved_as_outstanding': 'register.sale_saved_as_outstanding',
  'register.pos.delete_tooltip': 'register.pos.sale_delete_tooltip',
  'loyalty_points.types.spent_amount.heading_after':
    'loyalty_points.types.spent_amount.heading_after_new',
  'loyalty_points.types.per_visit.heading':
    'loyalty_points.types.per_visit.heading_new',
  'loyalty_points.types.per_visit.description':
    'loyalty_points.types.per_visit.description_new',
  'admin.booking.online_payment.payment_link_info.text':
    'admin.booking.online_payment.payment_link_info.text_new',
  'admin.user_accounts.modal.permissions.basic.description':
    'admin.user_accounts.modal.permissions.basic.description_new',
};

export const compliantKey = (oldKey: string) => {
  if (hasFeatureFlag('compliant-register')) {
    return compliantKeys[oldKey as keyof typeof compliantKeys] || oldKey;
  }
  return oldKey;
};

export const orderKey = (type: 'single' | 'plural' = 'single') => {
  if (hasFeatureFlag('compliant-register')) {
    return type === 'plural' ? 'sales' : 'sale';
  }
  return type === 'plural' ? 'invoices' : 'invoice';
};
